import React from 'react';
import { Reveal } from './Reveal';
import { kitContents } from '../data/kitContents';
export function KitContentsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-118" data-mp="209o2oa1qn9ku">
      <Reveal className="mx-auto max-w-5xl" data-id="element-119" data-mp="257pm4w32tawu">
        <div className="mb-12 text-center" data-id="element-120" data-mp="256xozgttz54g">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-121" data-mp="2a725v7yni1v7">TUTTO IN UN UNICO PACK</p>
          <h2 className="text-3xl font-extrabold text-brand-blue md:text-4xl" data-id="element-122" data-mp="2f783d4rlqil7">📋 Cosa Contiene ARTE PRONTA™?</h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-123" data-mp="2j6gxiaqk0iha">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-2xl border border-brand-dark bg-brand-main p-7 text-center" data-id="element-124" data-mp="2sxtn0vovqwk5">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-blue" strokeWidth={1.5} aria-hidden="true" data-id="element-125" data-mp="2xyr3n3u8rijj" />
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-blue" data-id="element-126" data-mp="32twn7w068l4g">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-127" data-mp="10jjazwa2pw3p">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}